// extracted by mini-css-extract-plugin
export default {"InterviewDetails":"styles_InterviewDetails__5KfpX","title":"styles_title__9QWeo","form":"styles_form__rAxax","input":"styles_input__aJ53s","location":"styles_location__VF9-Y"};